module.exports = __webpack_public_path__ + "media/images/flags/bz-79c87f6f1c145c0c745fbe8c81a56eef.svg";